<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-start">
  <h4>{{ 'profiles.view.sales-opps.label' | translate | titlecase }}</h4>
  <a *ngIf="profileContactsTabFullAccess" (click)="salesOppDialog.openWithProfileId(profileId)">{{
    'profiles.view.sales-opps.add-a-sales-opp' | translate | titlecase
  }}</a>
</div>
<div
  class="mct-flex mct-col mct-justify-between mct-items-stretch"
  *ngFor="let opp of salesOpps; last as isLast"
  [ngClass]="opp.Closed || opp.Lost ? 'light-text mb-54' : 'mb-54'"
>
  <div class="mb-12 mct-grid-gt-sm sales-opp-grid-3col-b mct-grid-lt-md mct-cols-1-1-lt-md mct-auto-rows-min">
    <div class="f-wb mct-col-1-span-2-lt-md">
      {{ opp.RevenueItem ? (opp.RevenueItem.Descr ? opp.RevenueItem.Descr : opp.RevenueItem.ItemName) : '' }}
    </div>
    <div *ngIf="!opp.Started" class="light-text mct-col-1-span-2-lt-md">
      {{ 'profiles.view.sales-opps.not-started' | translate | ucfirst }}
    </div>
    <div *ngIf="opp.Started && !opp.Closed && !opp.Lost" class="f-wb mct-col-1-span-2-lt-md">
      {{ 'profiles.view.sales-opps.started-on' | translate | ucfirst }}
      {{ opp.DateStarted | date : 'M/d/yyyy' }}
    </div>
    <div *ngIf="opp.Closed && !opp.Lost" class="f-wb mct-col-1-span-2-lt-md">
      {{ 'profiles.view.sales-opps.closed-on' | translate | ucfirst }}
      {{ opp.ClosedDate | date : 'M/d/yyyy' }}
    </div>
    <div *ngIf="opp.Lost" class="f-wb mct-col-1-span-2-lt-md">
      {{ 'profiles.view.sales-opps.lost-on' | translate | ucfirst }}
      {{ opp.LostDate | date : 'M/d/yyyy' }}
      ({{ opp.LostReason }})
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch mct-col-1-span-2-lt-md" *ngIf="profileContactsTabFullAccess">
      <a (click)="deleteOpp(opp.SalesID)" class="light-text">{{ 'common.delete' | translate | titlecase }}</a>
      &nbsp;&nbsp;•&nbsp;&nbsp;
      <a (click)="salesOppDialog.open(opp.SalesID)">{{ 'common.edit' | translate | titlecase }}</a>
    </div>
  </div>
  <div class="mb-27 mct-grid-gt-sm sales-opp-grid-3col-a mct-grid-lt-md mct-cols-1-1-lt-md mct-auto-rows-min mct-gap-10-0-lt-md">
    <div class="mct-flex mct-col">
      <span class="light-text">{{ 'profiles.view.sales-opps.estimated-amount' | translate | titlecase }}</span>
      {{ opp.EstimatedAmount | currency }}
    </div>
    <div class="mct-flex mct-col">
      <span class="light-text">{{ 'profiles.view.sales-opps.estimated-close' | translate | titlecase }}</span>
      {{ opp.EsitmatedClose | date : 'M/d/yyyy' }}
    </div>
    <div class="mct-flex mct-col">
      <span class="light-text">{{ 'profiles.view.sales-opps.assigned-to' | translate | titlecase }}</span>
      <span>{{ opp.AssignedToUser?.FullName }}</span>
    </div>
  </div>
  <div class="mct-grid-gt-sm sales-opp-grid-2col mct-grid-lt-md mct-cols-1-1-lt-md mct-auto-rows-min">
    <div class="mct-flex mct-col">
      <span class="light-text">{{ 'profiles.view.sales-opps.probability' | translate | titlecase }}</span>
      <span>{{ opp.Probability }}</span>
    </div>
    <div class="mct-flex mct-col">
      <span class="light-text">{{ 'profiles.view.sales-opps.working-with' | translate | titlecase }}</span>
      <span>{{ opp.WorkingWithProfile?.ReportName }}</span>
    </div>
  </div>
  <hr [hidden]="isLast" />
</div>

<wl-sales-opportunity-edit-dialog #salesOppDialog></wl-sales-opportunity-edit-dialog>

<p-confirmDialog #deleteSalesOppCD key="deleteSalesOppCD">
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="deleteSalesOppCD.reject()" class="atlas-btn atlas-btn-secondary mr-10">{{ rejectText }}</button>
    <button pButton type="button" (click)="deleteSalesOppCD.accept()" class="atlas-btn atlas-btn-primary">{{ acceptText }}</button>
  </ng-template>
</p-confirmDialog>
